//@ts-nocheck
import React from "react";
import {
  withStyles,
  Grid,
  Typography,
  createStyles,
  Button,
  Box,
  Link,
  Hidden,
} from "@material-ui/core";
import addImg from "../../assets/0937e2df00dec93b5a6feecbdcc621dc27832c38.png";
import moment from "moment";
import CustomGrid from "../../../../components/src/CustomGrid.web";
import CustomTypography from "../../../../components/src/CustomTypography.web";
import TernaryCheck from "../TernaryCheck.web";
import { IconRenderer } from "../../../../components/src/IconPicker";

// Constants
const DEFAULT_MULTIPLIER_VALUE = 1;

export type Props = {
  id: string;
  selectedPackageList: [];
  // Customizable Area Start
  // Customizable Area End
};

export const ExecutionAndNextSteps = ({ classes, roadmap }) => {
  const executions = roadmap?.attributes?.executions;
  const allNotes = roadmap?.attributes?.notes?.data;
  const notes = allNotes?.filter((note, index, self) =>
    index === self.findIndex(n => n.attributes.title === note.attributes.title)
  );
  const primaryColor = roadmap?.attributes?.add_primary_color || localStorage.getItem("primaryColor");
  
  const defaultExecutions = {
    "0": {
      "text": "We will work with you to define & prioritize work items based on your goals.",
      "is_checked": true
    },
    "1": {
      "text": "We will execute as many work items as are feasible for the engagement period & package chosen.",
      "is_checked": true
    },
    "2": {
      "text": "As work items are completed, we will update and re-prioritize action items to ensure our efforts are always focused on your immediate needs.",
      "is_checked": true
    }
  };
  
  return (
    <>
      <CustomGrid item xs={12} margin="2rem 0 0 0" padding="0 2rem">
        <CustomTypography
          className={classes.secondaryColorText}
          fontSize="1.7rem"
          fontWeight={700}
          id='sub-heading'
        >
          Execution
        </CustomTypography>
      </CustomGrid>

      <CustomGrid item xs={12} margin="0 0 1rem 0" padding="0 2rem">
        {(() => {
          const executionsToRender = (executions && Object.keys(executions).length > 0) ? executions : defaultExecutions;
          
          return Object.values(executionsToRender)
            .filter(execution => {
              return typeof execution === 'string' || execution.is_checked === true || execution.is_checked === 'true';
            })
            .map((execution, index) => (
            <Grid key={index} item xs={12} container alignItems="center">
              <Typography className={classes.executionFeatures} id='pdf-arrows' id='main-heading-second'>
                <Box className={classes.smallTriangleRight} sx={{ mr: 1.5 }} />
                {typeof execution === 'string' ? execution : execution.text}
              </Typography>
            </Grid>
          ));
        })()}
      </CustomGrid>

      <Box
        sx={{
          width: '100%',
          maxWidth: '1200px',
          margin: '2rem auto',
          padding: '0 2rem',
          textAlign: 'center',
        }}
      >
        <CustomTypography
          className={classes.secondaryColorText}
          fontSize="1.7rem"
          fontWeight={700}
          style={{ textAlign: "center" }}
          id='sub-heading'
        >
          Next Steps
        </CustomTypography>
    

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'stretch',
          gap: '1rem',
          padding: '1rem 2rem',
          width: '100%',
          maxWidth: '1200px',
          margin: '1rem auto',
        }}
      >
        {notes?.length > 0 ? (
          notes
            .filter(note => {return !note.attributes.hasOwnProperty('is_checked') || note.attributes.is_checked === true || note.attributes.is_checked === 'true';})
            .map((note, index) => (
            <Box
              key={note.id || index}
              className={`${classes.boxStyle2} next-step-box`}
              style={{ backgroundColor: primaryColor || undefined }}
              sx={{
                minWidth: { xs: '280px', sm: '200px', md: '180px' },
                maxWidth: { xs: '100%', sm: '45%', md: '300px' },
                flex: '1 1 calc(33.333% - 1rem)',
              }}
            >
              <IconRenderer
                icon={note.attributes.icon || 'Star'}
                style={{ 
                  width: '35%', 
                  height: '35%', 
                  color: 'white' 
                }}
              />
              <Typography className={classes.nextStepsPrimaryText} id='sub-heading'>
                {note.attributes.title}
              </Typography>
              <Typography className={classes.nextStepsSecondaryText} id='main-heading-second'>
                {note.attributes.description}
              </Typography>
            </Box>
          ))  
        ) : (
          // Fallback to default notes
          <>
            <Box
              className={`${classes.boxStyle2} next-step-box`}
              style={{ backgroundColor: primaryColor || undefined }}
              sx={{
                minWidth: { xs: '280px', sm: '200px', md: '180px' },
                maxWidth: { xs: '100%', sm: '45%', md: '300px' },
                flex: '1 1 calc(33.333% - 1rem)',
              }}
            >
              <IconRenderer
                icon="Check"
                style={{ 
                  width: '35%', 
                  height: '35%', 
                  color: 'white' 
                }}
              />
              <Typography className={classes.nextStepsPrimaryText} id='sub-heading'>
                Decision
              </Typography>
              <Typography className={classes.nextStepsSecondaryText} id='main-heading-second'>
                Choose the option that best fits your needs.
              </Typography>
            </Box>

            <Box
              className={`${classes.boxStyle2} next-step-box`}
              style={{ backgroundColor: primaryColor || undefined }}
              sx={{
                minWidth: { xs: '280px', sm: '200px', md: '180px' },
                maxWidth: { xs: '100%', sm: '45%', md: '300px' },
                flex: '1 1 calc(33.333% - 1rem)',
              }}
            >
              <IconRenderer
                icon="Briefcase"
                style={{ 
                  width: '35%', 
                  height: '35%', 
                  color: 'white' 
                }}
              />
              <Typography className={classes.nextStepsPrimaryText} id='sub-heading'>
                Onboarding
              </Typography>
              <Typography className={classes.nextStepsSecondaryText} id='main-heading-second'>
                eSign your enrollment documents, make your payment, & we will
                designate resources for your work.
              </Typography>
            </Box>

            <Box
              className={`${classes.boxStyle2} next-step-box`}
              style={{ backgroundColor: primaryColor || undefined }}
              sx={{
                minWidth: { xs: '280px', sm: '200px', md: '180px' },
                maxWidth: { xs: '100%', sm: '45%', md: '300px' },
                flex: '1 1 calc(33.333% - 1rem)',
              }}
            >
              <IconRenderer
                icon="Phone"
                style={{ 
                  width: '35%', 
                  height: '35%', 
                  color: 'white' 
                }}
              />
              <Typography className={classes.nextStepsPrimaryText} id='sub-heading'>
                Kickoff Call
              </Typography>
              <Typography className={classes.nextStepsSecondaryText} id='main-heading-second'>
                We can schedule a kickoff call to get started!
              </Typography>
            </Box>
          </>
        )}
      </Box></Box>
    </>
  );
};

export class RoadMapUI extends React.Component {
  constructor(props: Props) {
    super(props);
  }
  
  savePDFMeta = () => {
  let finalLogo = this.props.logo ? this.props.logo : addImg;

  const phoneText = this.getPhoneNumber()||""
   

  const disclaimer =
    this.props.roadmap?.attributes?.confidential_statement ||
    "This has been prepared for the purpose of providing tax, accounting and strategic advisory services. This information should not be shared, has not been audited, and does not imply we're providing investment advice.";

  const finalData = {
    logo: finalLogo,
    text: phoneText,
    disclaimer: disclaimer
  };

  localStorage.setItem("pdfFooter", JSON.stringify(finalData));
};

  formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    let match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      let intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return null;
  };

  getPhoneNumber = () => {
    let number = "";
    if (
      this.props.roadmap?.attributes?.phone_number &&
      this.props.roadmap?.attributes?.web_url
    ) {
      number = ` ${this.props.roadmap?.attributes?.country_code} ${this.props.roadmap?.attributes?.phone_number}`;
    } else if (this.props.roadmap?.attributes?.phone_number) {
      number = `${this.props.roadmap?.attributes?.country_code} ${this.props.roadmap?.attributes?.phone_number}`;
    }

    return number
  };


  mapOfPackageHeadings = (paymentTerm, index) => {
    const { classes } = this.props;
    const isSelected =
      paymentTerm.id &&
      paymentTerm.id === this.props?.selectedPaymentTerm?.id &&
      paymentTerm?.attributes?.selectedPaymentTerm?.paymentTermKey ==
        this.props?.selectedPaymentTerm?.attributes?.selectedPaymentTerm
          ?.paymentTermKey;
    const is_payment_terms_recommended=paymentTerm.attributes.payment_term.is_payment_terms_recommended
    const packageClass = isSelected ? classes.selectedPackageCard : classes.packageCard;
    let categories = paymentTerm?.attributes?.features?.data || [];
    const categoryOrder = [];

    categories.forEach((item) => {
      const cat = item?.attributes?.custom_package_feature_category_name || "Other";

      if (!categoryOrder.includes(cat) && cat !== "Other") {
        categoryOrder.push(cat);
      }
    });

    categoryOrder.push("Other");

    const groupedCategories = categories.reduce((acc, category) => {
      const groupName =
        category?.attributes?.custom_package_feature_category_name || "Other";

      if (!acc[groupName]) acc[groupName] = [];
      acc[groupName].push(category);
      return acc;
    }, {});

    const sortedGroupKeys = Object.keys(groupedCategories).sort((a, b) => {
      return categoryOrder.indexOf(a) - categoryOrder.indexOf(b);
    });
    const primaryStoredColor= localStorage.getItem("primaryColor")
    let boxShadowStyle = "";

    if (isSelected) {
      boxShadowStyle = `0px 0px 12px 0px ${primaryStoredColor}`;
    } else if (is_payment_terms_recommended) {
      boxShadowStyle = `1px 1px 20.4px 0px ${primaryStoredColor}`;
    } else {
      boxShadowStyle = `0px 2px 4.2px 0px ${primaryStoredColor} inset`;
    }

    return (
      <Grid item xs={12} sm={4} md={4} key={index}>
        <Box
          style={{
            position: "relative",
            width: "95%",
            display: "block",
          }}
        >
          <Box id='popular-box'
          className={classes.popularBoxStyle}
            style={{
              display:
                is_payment_terms_recommended
                  ? "flex"
                  : "none",
              justifyContent: "center",
            }}
          >
            <svg
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="8.5"
                  r="5"
                  stroke="white"
                  strokeWidth="1.5"
                  fill="none"
                />

                <path
                  d="M12 5.8L12.9 7.7L14.9 8L13.4 9.4L13.8 11.3L12 10.3L10.2 11.3L10.6 9.4L9.1 8L11.1 7.7L12 5.8Z"
                  fill="white"
                />

                <path
                  d="M7 12V18L14 12.5"
                  fill="white"
                />
                <path
                  d="M 17 12 V 18 L 10 12.5"
                  fill="white"
                />
            </svg>

            <Typography style={{marginTop:'4px'}} id="popular-text">RECOMMENDED PLAN</Typography> 
             <svg
                width={32}
                height={32}
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="8.5"
                  r="5"
                  stroke="white"
                  strokeWidth="1.5"
                  fill="none"
                />

                <path
                  d="M12 5.8L12.9 7.7L14.9 8L13.4 9.4L13.8 11.3L12 10.3L10.2 11.3L10.6 9.4L9.1 8L11.1 7.7L12 5.8Z"
                  fill="white"
                />

                <path
                  d="M7 12V18L14 12.5"
                  fill="white"
                />
                <path
                  d="M 17 12 V 18 L 10 12.5"
                  fill="white"
                />
            </svg>
          </Box>

          <Box
            id='package-shadow'
            className={packageClass}
            style={{
              marginTop: is_payment_terms_recommended
                ? `-20px`
                : "0px",
              position: "relative",
              // boxShadow:'0px 2px 4.2px 0px #31C1C5 inset',
              zIndex: 2,
              boxShadow:boxShadowStyle,
              overflow: "hidden",
              borderRadius: "14.2px",
              background:'#fff'
            }}
          >
            <CustomTypography
              fontSize="1.5rem"
              fontWeight={700}
              margin="1rem 0 0.5rem 0"
              className={classes.packageIndex}
              id='main-heading-second'
            >
              Package - {index + 1}
            </CustomTypography>

            <CustomTypography
            id='main-heading-second'
              fontSize="1.2rem"
              fontWeight={700}
              margin="0 0 0.25rem 0"
              color="#444545"
            >
              {paymentTerm?.attributes?.name}
            </CustomTypography>

            <CustomTypography fontSize="24px" margin="0 0 0.5rem 0" color="#444545" fontWeight={700}
            id='main-heading'>
              {paymentTerm?.attributes?.selectedPaymentTerm?.value}
            </CustomTypography>

            <TernaryCheck
              condition={this.props.isPackageSelectable}
              trueComponent={
                <Button
                  className={classes.buttonStyle}
                  onClick={() => this.props?.handleSelectPaymentTerm(paymentTerm)}
                >
                  Select this Package
                </Button>
              }
              falseComponent={null}
            />

            <TernaryCheck
              condition={paymentTerm?.attributes?.package_detail_link}
              trueComponent={
                <Link
                  href={
                    paymentTerm?.attributes?.package_detail_link?.indexOf("https") === 0
                      ? paymentTerm?.attributes?.package_detail_link
                      : `https://${paymentTerm?.attributes?.package_detail_link}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                  underline="none"
                >
                  <Typography style={{ textAlign: "center", fontSize: "14px" }} className={classes.packageIndex}>
                    More Details
                  </Typography>
                </Link>
              }
              falseComponent={null}
            />

            {sortedGroupKeys.map((groupName) => (
              <div key={groupName} style={{ marginBottom: "1.5rem" }}>
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 700,
                    fontSize: "16.3px",
                    color: "#444545",
                    textAlign: "left",
                    marginBottom: "5px",
                    paddingLeft: "30px",
                  }}
                >
                  {groupName}
                </Typography>

                {groupedCategories[groupName].map((category) => (
                  <div key={category?.attributes?.feature_name}>
                    <Typography color="textSecondary" className={classes.featureText2}>
                      <Box className={classes.checkMark} id='pdf-checkmark' />
                      {category?.attributes?.feature_name}
                    </Typography>

                    {category?.attributes?.custom_package_bumps?.data?.map((bumps, key) => {
                      const { bump_name, bump_multiplier } = bumps?.attributes || {};
                      return (
                        <Typography
                          key={key}
                          color="textSecondary"
                          className={classes.featureText2}
                          style={{ marginLeft: "2rem", fontSize: "1rem" }}
                        >
                          <Box className={classes.smallCheckMark} />
                          {bump_name}
                          {bump_multiplier && bump_multiplier !== DEFAULT_MULTIPLIER_VALUE && (
                            <>
                              <span
                                style={{
                                  color: localStorage.getItem("primaryColor") || "#1976d2",
                                  margin: "0 1rem",
                                }}
                              >
                                x
                              </span>
                              {bump_multiplier}
                            </>
                          )}
                        </Typography>
                      );
                    })}
                  </div>
                ))}
              </div>
            ))}
          </Box>
        </Box>
      </Grid>
    );
  };

  sortPaymentTerms = (a, b) => {
    let fa = a?.attributes.selectedPaymentTerm?.order_number,
      fb = b?.attributes.selectedPaymentTerm?.order_number;

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  };

  renderPackageHeadings = () => {
    let handleArray = this.props.packagePaymentTerms.slice();
    handleArray.sort(this.sortPaymentTerms);
    return handleArray.map(this.mapOfPackageHeadings);
  };

  render() {
    const { classes } = this.props;
    return (
      <div id="pdf-section">
        <div class="pdf-page" id="page-1">
      <Grid container >
        <CustomGrid item xs={12} padding="0 2rem">
          <Grid container alignItems="center" justifyContent="space-between">
            <TernaryCheck
              condition={this.props.logo}
              trueComponent={
                <Grid item xs={2} className={classes.imageBox} id="pdf-logo">
                  <img
                    src={this.props.logo}
                    alt="No logo available"
                    className={classes.logoImage}
                  />
                </Grid>
              }
              falseComponent={
                <Grid item xs={2}>
                  <Box className={classes.logoBox}>
                    <img src={addImg} className={classes.defaultlogoImage} />
                    <Typography variant="body2" display="block" style={{marginTop:'3px'}}>
                      Your logo here
                    </Typography>
                  </Box>
                </Grid>
              }
            /> 
            <Grid item xs={3}>
              <CustomTypography
                color="textSecondary"
                fontSize="1.1rem"
                fontWeight={700}
                align="right"
                padding="0 1rem 0 0"
              >
                {moment(new Date()).format("MM-DD-YYYY")}
              </CustomTypography>
            </Grid>
          </Grid>
        </CustomGrid>
        <Grid
          item
          xs={12}
          container
          className={classes.borderBottom21}
          direction="column"
        >
          <Typography
            align="left"
            className={`${classes.pageTitle} ${classes.primaryColorText}`}
            style={{marginTop:'29px'}}
            id='main-heading'
          >
            My Roadmap
          </Typography>
          <CustomTypography
            id='pdf-title-font'
            align="left"
            margin="0 0 0.9rem 0"
            className={`${classes.pageTitle} ${classes.primaryColorText}`}
          >
            <span style={{ color: "black" }} id='pdf-title-font'>Prepared for </span>
            {(this.props.roadmap?.attributes?.client_informations || []).length === 0 && "NA"}
            {(this.props.roadmap?.attributes?.client_informations || []).map((client) => (
              <span key={client.id} style={{ display: "block" }}>
                {client.first_name || ""} {client.last_name || ""}
                {client.spouse_first_name ? ` & ${client.spouse_first_name} ${client.spouse_last_name || ""}` : ""}
              </span>
            ))}
          </CustomTypography>
        </Grid>

        <CustomGrid item xs={10} width="100%" padding="0 2rem 4rem 2rem">
          <CustomTypography
            color="textPrimary"
            fontSize="1.7rem"
            fontWeight={700}
            id='main-heading-second'
          >
            Progress you would like to make in the next 12 months:
          </CustomTypography>
          <Box className={classes.prioContainer}>
            <Hidden smDown>
              <Box className={classes.triangleRight} id='pdf-arrows' sx={{ mr: 2.2 }} />
            </Hidden>
            <CustomTypography
              color="textSecondary"
              fontSize="1.1rem"
              className={classes.priorityText}
            >
              {this.props.roadmap?.attributes?.client_informations[0]?.client_discovery?.inputField4?.firstPriority || "NA"}
            </CustomTypography>
            <Hidden smDown>
              <Box className={classes.triangleRight} id='pdf-arrows' sx={{ mr: 2.2 }} />
            </Hidden>
            <CustomTypography
              color="textSecondary"
              fontSize="1.1rem"
              className={classes.priorityText}
            >
              {this.props.roadmap?.attributes?.client_informations[0]?.client_discovery.inputField4?.secondPriority || "NA"}
            </CustomTypography>
            <Hidden smDown>
              <Box className={classes.triangleRight} id='pdf-arrows' sx={{ mr: 2.2 }} />
            </Hidden>
            <CustomTypography
              color="textSecondary"
              fontSize="1.1rem"
              className={classes.priorityText}
              id='third-priority'
            >
              {this.props.roadmap?.attributes?.client_informations[0]?.client_discovery?.inputField4?.thirdPriority || "NA"}
            </CustomTypography>
          </Box>
        </CustomGrid>
        </Grid>
        </div>
        <div id="other-pages-section">
        <div class="pdf-page" id="page-2">
       <Grid container>
        <CustomGrid id="ExecutionAndNextStepsconer" item xs={10} width="100%" margin="1rem 0 5rem 0">
          <CustomTypography
            align="center"
            className={classes.secondaryColorText}
            fontSize="1.7rem"
            fontWeight={900}
            id='sub-heading'
          >
            Your Package Options
          </CustomTypography>
        </CustomGrid>
        <Grid item xs={12}>
          <Grid container justifyContent="center" id='pdf-package-container'>
            {this.renderPackageHeadings()}
          </Grid>
        </Grid>
        </Grid>
        </div>
        <div className="page-break"></div>
        <div class="pdf-page" id="page-3">
       <Grid container >
        <div id="ExecutionAndNextStepsconer" style={{width : "100%"}}>
          <ExecutionAndNextSteps classes={classes} roadmap={this.props.roadmap} />
        </div>

        <CustomGrid
        className="logo-content"
          item
          xs={10}
          width="100%"
          margin="4rem auto"
          padding="0 2rem"
        >
          <CustomTypography 
            className={classes.secondaryColorText}
            fontSize="1.7rem"
            fontWeight={700}
          >
            Confidentiality & Disclaimer
          </CustomTypography>
          <Typography className={classes.disclaimerStyle}>
            {this.props.roadmap?.attributes?.confidential_statement ||
              "This has been prepared for the purpose of providing tax, accounting and strategic advisory services. This information should not be shared, has not been audited, and does not imply we're providing investment advice."}
          </Typography>
        </CustomGrid>

        <CustomGrid className="logo-content"
          item
          xs={10}
          width="96%"
          margin="1rem 2%"
          style={{
            boxShadow: "none",
          }}
        >
          <CustomGrid
            container
            justifyContent="flex-start"
            alignItems="center"
            xs={12}
            margin="0 0 0.75rem 0"
          >
            <TernaryCheck
              condition={this.props.logo}
              trueComponent={
                <img
                  src={this.props.logo}
                  alt="No logo available"
                  style={{
                    width: "100px",
                    marginRight: "1rem"
                  }}
                />
              }
              falseComponent={
                <Box className={classes.logoBox}>
                  <img
                    src={addImg}
                    className={classes.defaultlogoImage}
                  />
                  <Typography variant="body2" display="block" style={{marginTop:'3px'}}>
                    Your logo here
                  </Typography>
                </Box>
              }
            />
            <Grid item xs={6}>
              <TernaryCheck
                condition={this.props.roadmap?.attributes?.web_url}
                trueComponent={
                  <Link
                    href={
                      this.props.roadmap?.attributes?.web_url.indexOf(
                        "https"
                      ) === 0
                        ? this.props.roadmap?.attributes?.web_url
                        : `https://${this.props.roadmap?.attributes?.web_url}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    color="inherit"
                  >
                    <Typography
                      className={`${classes.primaryColorText} ${classes.urlAndPhoneText}`}
                      align="center"
                      display="inline"
                    >
                      {this.props.roadmap?.attributes?.web_url}
                    </Typography>
                    <TernaryCheck
                      condition={
                        this.props.roadmap?.attributes?.web_url &&
                        this.props.roadmap?.attributes?.phone_number
                      }
                      trueComponent={
                        <Typography
                          className={`${classes.primaryColorText} ${classes.urlAndPhoneText} ${classes.middleBar}`}
                          align="center"
                          display="inline"
                        >
                          |
                        </Typography>
                      }
                      falseComponent={null}
                    />
                  </Link>
                }
                falseComponent={null}
              />
              <Typography
                className={`${classes.primaryColorText} ${classes.urlAndPhoneText}`}
                align="center"
                display="inline"
              >
                {this.getPhoneNumber()}
              </Typography>
            </Grid>
          </CustomGrid>
        </CustomGrid>
        {this.savePDFMeta()}
      </Grid>
      </div>
      </div>
      </div>
    );
  }
}

export const roadmapStyles = (theme) => {
  return {
    prioContainer: {
      display: "flex",
      alignItems: "center",
      marginTop: "2.5rem",
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    priorityText: {
      paddingRight: "1rem",
      minWidth: "33%",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "1rem",
      },
    },
    iconStyle: {
      width: "13px",
      fill: localStorage.getItem("primaryColor") || theme.palette.primary.main,
    },
    primaryColorText: {
      color: localStorage.getItem("primaryColor") || theme.palette.primary.main,
    },
    secondaryColorText: {
      color:
        localStorage.getItem("secondaryColor") || theme.palette.secondary.main,
    },
    borderBottom21: {
      borderBottom: `1px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      margin: "0 2rem",
      marginBottom: "3rem",
    },
    logoBox: {
      border: "0.1px solid #6A6B6D",
      borderRadius: "12px",
      padding: "5px",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100px",
      height: "65px",
    },
    imageBox: {
      borderRadius: theme.spacing(1.5),
      textAlign: "center",
      height: theme.spacing(15),
      width: theme.spacing(15),
    },
    defaultlogoImage: {
      height: "50%",
    },
    logoImage: {
      height: "100%",
    },
    pageTitle: {
      fontSize: "2.2rem",
      fontWeight: "bold",
    },
    urlAndPhoneText: {
      [theme.breakpoints.up("md")]: {
        fontSize: "18px",
      },
    },
    boxStyle2: {
      borderRadius: 15,
      backgroundColor: theme.palette.primary.main,
      textAlign: "center",
      padding: "1rem",
      margin: "0.5rem",
      // minHeight: "200px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      flex: "1 1 auto",
      [theme.breakpoints.down("sm")]: {
        margin: "0.5rem auto",
        minHeight: "180px",
        maxWidth: "calc(50% - 1rem)",
      },
      [theme.breakpoints.down("xs")]: {
        maxWidth: "calc(100% - 1rem)",
      },
    },
    nextStepsPrimaryText: {
      fontSize: "2rem",
      fontWeight: 900,
      color: "white",
      marginTop: "1rem",
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5rem",
      },
    },
    nextStepsSecondaryText: {
      fontSize: "1rem",
      fontWeight: "normal",
      color: "white",
      margin: "0.8rem 0",
    },
    packageCard: {
      flexGrow: "0",
      maxWidth: "100%",
      flexBasis: "30%",
      // boxShadow: "0px 0px 6px 2px rgba(0, 0, 0, 0.1)",
      boxShadow: '0px 2px 4.2px 0px #31C1C5 inset',
      borderRadius: "2rem",
      margin: "0 1.5%",
      textAlign: "center",
      padding: "1rem",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        flexBasis: "60%",
        margin: "1rem auto",
      },
    },
    selectedPackageCard: {
      flexGrow: "0",
      flexBasis: "30%",
      border: `1px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      boxShadow: `0px 0px 12px 0px ${localStorage.getItem("primaryColor") ||
         theme.palette.primary.main}`,
      borderRadius: "2rem",
      margin: "0 1.5%",
      textAlign: "center",
      padding: "1rem",
      [theme.breakpoints.down("sm")]: {
        flexBasis: "60%",
        margin: "1rem auto",
      },
    },
    packageIndex: {
      color: localStorage.getItem("secondaryColor") || theme.palette.primary.main,
    },
    featureText2: {
      marginBottom: "0.75rem",
      fontSize: "1.1rem",
      position: "relative",
      padding: "0 1.25rem",
      display: "flex",
      alignItems: "flex-start",
      textAlign: "left",
    },
    popularBoxStyle:{
      background: localStorage.getItem("primaryColor"),
              borderTopLeftRadius: "14.2px",
              borderTopRightRadius: "14.2px",
              height: 70,
              width: "96.5%",
              color: "#fff",
              fontWeight: 600,
              fontSize: "13.04px",
              marginLeft:'6px',
              paddingTop:'13px',
              gap:10,
              "@media screen and (max-width: 959px)": {
          height:'60px',
        },
    },
    checkMark: {
      display: "inline-block",
      transform: "rotate(45deg)",
      width: "6px",
      height: "12px",
      borderBottom: `2px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      borderRight: `2px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      marginRight: "1rem",
      marginTop: "0.35rem",
    },
    smallCheckMark: {
      display: "inline-block",
      position: "relative",
      width: "10px",
      height: "10px",
      marginRight: "0.75rem",
      marginTop: "0.25rem",
      "&::before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "8px",
        height: "1.5px",
        backgroundColor: localStorage.getItem("primaryColor") || theme.palette.primary.main,
      },
      "&::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "1.5px",
        height: "8px",
        backgroundColor: localStorage.getItem("primaryColor") || theme.palette.primary.main,
      },
    },
    disclaimerStyle: {
      color: theme.palette.text.secondary,
      fontSize: "1rem",
      marginTop: "10px",
    },
    executionFeatures: {
      display: "flex",
      fontSize: "1.1rem",
      fontWeight: "bold",
      color: theme.palette.text.secondary,
      lineHeight: 1,
      padding: "1rem 0",
      paddingLeft: "0.8rem",
      width: "calc(100% - 1.5rem)",
      borderRadius: "0.5rem",
      marginBottom: "0.75rem",
      alignItems: "center",
      textAlign:'justify'
    },
    middleBar: {
      margin: "0px 10px",
    },
    triangleRight: {
      width: "0px",
      height: "0px",
      borderTop: "10px solid transparent",
      borderLeft: `20px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      borderBottom: "10px solid transparent",
    },
    smallTriangleRight: {
      width: "0px",
      height: "0px",
      borderTop: "7px solid transparent",
      borderLeft: `14px solid ${localStorage.getItem("primaryColor") ||
        theme.palette.primary.main}`,
      borderBottom: "7px solid transparent",
    },
    buttonStyle: {
      color: "#fff",
      padding: "10px 20px",
      borderRadius: "25px",
      margin: "15px auto 10px ",
      fontWeight: 700,
      backgroundColor:
        localStorage.getItem("secondaryColor") || theme.palette.secondary.main,
      display: "block",
      textTransform: "inherit",
      textAlign: "center",
      "&:hover": {
        backgroundColor:
          localStorage.getItem("secondaryColor") ||
          theme.palette.secondary.main,
      },
    },
  };
};

export default withStyles((theme) =>
  createStyles({
    rootChildContainerpdf: {
      [theme.breakpoints.up("md")]: {
        padding: "1.5rem 2rem 2rem 2rem",
      },
      [theme.breakpoints.down("md")]: {
        padding: "1rem",
      },
    },
    ...roadmapStyles(theme),
  })
)(RoadMapUI);
